module.exports = __webpack_public_path__ + "img/embedded3.a7ae2710.png";